import { Tooltip } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import {
  MENU_BUILDER_NAV_LABEL,
  MENU_BUILDER_NAV_TOOLTIP,
} from 'src/constants/menuBuilderNavCopy'
import { useVenueNavTooltipOpen } from 'src/hooks/useVenueNavTooltipOpen'
import { closeVenueNavTooltips } from 'src/utils/venueNavTooltip'

/**
 * Venue top-nav link. Tooltip is the cost / GP job — no extra label in the tab.
 * Same one-at-a-time dismiss as VenueNavTooltipLink.
 */
const MenuBuilderNavLink = ({ venueId }) => {
  const to = `/v/${venueId}/menu-builder`
  const [open, onVisibleChange] = useVenueNavTooltipOpen(to)

  return (
    <Tooltip
      title={MENU_BUILDER_NAV_TOOLTIP}
      placement='bottom'
      visible={open}
      onVisibleChange={onVisibleChange}
      mouseEnterDelay={0.35}
      mouseLeaveDelay={0}
      destroyTooltipOnHide
      overlayClassName='venue-nav-tooltip'
      overlayStyle={{ pointerEvents: 'none' }}
      getPopupContainer={() => document.body}
    >
      <Link
        to={to}
        data-testid='menu-builder-nav-link'
        onClick={closeVenueNavTooltips}
      >
        {MENU_BUILDER_NAV_LABEL}
      </Link>
    </Tooltip>
  )
}

export default MenuBuilderNavLink
